import React from 'react'
import "./Projects.css";
const Projectss = () => {
  return (
    <div className="project">
      <p>Projects<br/>
      <a href="https://paste-app-cr3k.vercel.app/">
      <button className="todo">To-Do List Application</button></a>
<br/>

Tech Stack: MongoDB, Express.js, ReactJS, Node.js, CSS
A full-stack To-Do List application enabling users to efficiently manage their daily tasks. Features include user authentication, task creation, editing, deletion, and real-time synchronization with a MongoDB database through a RESTful API built with Express and Node.js. The responsive UI is built with ReactJS, ensuring smooth user experience across devices.
<br/>
<br/>
Weather App<br/>
Tech Stack: MongoDB, Express.js, ReactJS, Node.js, CSS, Third-Party Weather API
A sophisticated weather forecasting application that allows users to search for and view real-time weather data by city. Built with a MERN stack backend to handle user requests and caching, it integrates third-party APIs for accurate weather information. The app supports user preferences saved in a database and features a dynamic, responsive interface developed using ReactJS.</p>
    </div>
  )
}

export default Projectss
